export const PAYMENT_ERRROR_MESSAGE_MAPPING = {
  NOT_SUFFICIENT_FUNDS:
    'Your payment could not be collected as there were not sufficient funds available. <br><br>Please try again using a different credit card.',
  BANK_REJECTED:
    'Your payment could not be collected as your bank is not allowing us to collect these payments. <br><br>Please try again using a different credit card, or contact your bank to authorise these payments and then try again.',
  CARD_EXPIRED:
    'Your payment could not be collected as it appears that your card may have expired. <br><br>Please try again using a different credit card or use an updated expiry date',
  CARD_NOT_VALID:
    'Your payment could not be collected as it appears that your card number is not valid. <br><br>Please try again checking the card details you enter are correct, or try  again using a different credit card.',
  ACCOUNT_CLOSED:
    'Your payment could not be collected it appears that your account may have been closed. <br><br>Please try again using a different credit card, or contact your bank to authorise these payments and then try again.',
  DEFAULT:
    'Your payment could not be collected, please try again later. If the problem persists, contact our support team for assistance.'
};

export const PAYMENT_RESPONSE_CODE = {
  NOT_SUFFICIENT_FUNDS: '51',
  BANK_REJECTED: ['2', '04', '41'],
  CARD_EXPIRED: '54',
  CARD_NOT_VALID: '14',
  ACCOUNT_CLOSED: '3'
};
